/* eslint 'no-useless-escape':'off', no-unused-vars: 'off' */
import React, { useState, useRef, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Col, Button, FormGroup, Form } from 'reactstrap';
import { Icon } from 'semantic-ui-react';
import Alert from 'react-bootstrap/Alert';
import { SaveAttachmentFromServiceRequest, GetWOFormCustomFields, GetWOFormTenantLists } from '../../../../action/workorderAction';
import SuccessImg from '../../../../Assets/images/success.gif';
import DangerImg from '../../../../Assets/images/Critical_Error.png';
import Attachments from'./Attachments';
import { ServiceRequestContext } from "../../../../index";
import TextColorSelector from "./TextColorSelector";
import InputMask from "react-input-mask";
import { sendSingleAmplitudeEvent } from 'amplitude/amplitude';
import APIutil from "api/APIutils";
import * as url from "api/url";
import { setAmplitudeEvent } from 'amplitude/amplitude';

const IconStyle = {
    float:'left',
    height:"13px",
    margin:"3px"
}

export default function ContentPane() {
   
    /*context*/
    const { ServiceRequestDetails, WOTenantStdFieldDetails } = useContext(ServiceRequestContext);
    const { colorCode, companyName} = ServiceRequestDetails[0];

    /*Get text color based on background color*/
    const textColor = TextColorSelector(colorCode)

    /*state declarations */
    const [ShowAlert, setShowAlert] = useState(false);
    const [IsSubmitClicked, setIsSubmitClicked] = useState(false);
    const [FirstNameError, setFirstNameError] = useState(false);
    const [LastNameError, setLastNameError] = useState(false);
    const [EmailAddressError, setEmailAddressError] = useState(false);
    const [DescriptionError, setDescriptionError] = useState(false);
    const [PhoneNumberError, setPhoneNumberError] = useState(false);
    const [EmailAddressErrorMsg, setEmailAddressErrorMsg] = useState(false);
    const [FilesLists, setFilesLists] = useState([]);
    const [serviceReuqestID, setServiceRequestID] = useState(0);
    const [IsVerbiageChecked, setIsVerbiageChecked] = useState(false);
    const [IsSaveClickedOnce, setSaveClickedOnce] = useState(false);
    const [PhoneNumber, setPhone] = useState('');
    const [PhoneNumberErrorMsg, setPhoneNumberErrorMsg] = useState(false);
    const [SiteKey, setSiteKey] = useState("");
    const [CustomFieldList, setCustomFieldList] = useState([]);
    const [CustomFieldError, setCustomFieldError] = useState(false);
    const [CustomFieldCols, setCustomFieldCols] = useState([]);
    const [ShowError, setShowError] = useState(false);
    const [ErrorMsg, setErrorMsg] = useState("");
    const [TenantListDropdown, setTenantListDropdown] = useState([]);
    const [TenantError, setTenantError] = useState(false);
    const [TenantFieldValue, setTenantFieldValue] = useState("0");

    /*ref declaration*/
    const FirstNameRef = useRef();
    const LastNameRef = useRef();
    const EmailAddressRef = useRef();
    const DescriptionRef = useRef();
    const childAttachmentClearFunc = useRef(null);
    const txtfirstName = useRef();
    const txtlastName = useRef();
    const txtemailAddress = useRef();
    const txtPhoneNo = useRef();
    const txtdescription = useRef();
    const chk_verbiage = useRef();
    const customFieldTextRef = useRef([]);
    const customFieldDdlRef = useRef([]);
    const TenantRef = useRef();

    /*map state to props*/
    const customFields = useSelector(state => state.WorkorderRootReducer.WorkOrderFormCustomFields);
    const tenantLists = useSelector(state => state.WorkorderRootReducer.WorkOrderFormTenantLists);
    
    /*map dispatch to props*/
    const dispatch = useDispatch();

    /*global variable*/
    var default_drop_down_value = <option value="" id="0" selected>{"Select"}</option>

    useEffect(() => {
        APIutil.getDataAPI(url.get_WorkOrder_Form_sitekey).then(
            response => {
                // if (response.status === 200) {
                    let SITE_KEY = response.siteKey;
                    if(SITE_KEY !== undefined && SITE_KEY !== ""){
                        const loadScriptByURL = (id, url, callback) => {
                            const isScriptExist = document.getElementById(id);
        
                            if (!isScriptExist) {
                                var script = document.createElement("script");
                                script.type = "text/javascript";
                                script.src = url;
                                script.id = id;
                                script.onload = function () {
                                    if (callback) callback();
                                };
                                document.body.appendChild(script);
                            }
        
                            if (isScriptExist && callback) callback();
                        }
        
                        // load the script by passing the URL
                        loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/enterprise.js?render=${SITE_KEY}`, function () {
                            console.log("Script loaded!");
                        });
                        setSiteKey(SITE_KEY);
                    }
                // }
            })
    }, []);

    useEffect(() => {
        dispatch(GetWOFormCustomFields());
        dispatch(GetWOFormTenantLists());
    },[])

    useEffect(() => {
        if(customFields !== undefined && customFields !== null && customFields.length){
            const l_rows = []
            const customFieldsLst = customFields.filter(el => el.isServiceRequestDisplay === true)
            if(customFieldsLst !== undefined && customFieldsLst !== null && customFieldsLst.length){
                const customFieldsOrder = OnSort(customFieldsLst);
                const customFieldsRow = customFieldsOrder.map((item) => {
                    if(item.fieldType === 0){
                        return  <Col sm={{ size: 6 }} id={item.fieldId} className="customFieldsTxt">
                                    <label id={item.fieldLabel + item.fieldId} className="ServiceRequest_Content_lbl">{item.required ? item.fieldLabel+" (req.)" : item.fieldLabel}</label>
                                    <br />
                                    <input id={"txt" + item.fieldLabel + item.fieldId}
                                        onFocus={()=>onCustomControlFocusChangeStyle(item.fieldLabel + item.fieldId,
                                                item.fieldLabel + item.fieldId + "error",
                                                "txt" + item.fieldLabel + item.fieldId)}  
                                        onBlur={()=>onBlurChangeStyle(item.fieldLabel + item.fieldId)} type="text" 
                                        autoComplete="do-not-show-ac"
                                        className="ServiceRequest_Content_txtbox" maxLength={50} ref={(el) => {customFieldTextRef.current[item.fieldId] = el}}/>
                                    <span id={item.fieldLabel + item.fieldId + "error"} hidden={true}>
                                        <img style={IconStyle} src={DangerImg} alt="danger_img" />
                                        <label style={{ 'color': '#D52B1E', 'font-size': '12px', 'font-family': 'Arial', 'margin': '1px' }}></label>
                                    </span>
                                </Col>
                    }else{
                        var customField_In_Select_Input
                        if(item.value !== null && item.value !== undefined && item.value.length){
                            var customValues = OnSort(item.value)
                            customField_In_Select_Input = customValues.map(el => (
                                <option id={el.key}>{el.value}</option>
                            ))
                        }
                        return  <Col sm={{ size:6 }} id={item.fieldId} className="customFieldsDdl">
                                    <label id={item.fieldLabel + item.fieldId} className="ServiceRequest_Content_lbl">{item.required ? item.fieldLabel+" (req.)" : item.fieldLabel}</label>
                                    <br />
                                    <select 
                                        onFocus={()=>onCustomControlFocusChangeStyle(item.fieldLabel + item.fieldId,
                                            item.fieldLabel + item.fieldId + "error",
                                            "drp" + item.fieldLabel + item.fieldId)}  
                                        onBlur={()=>onBlurChangeStyle(item.fieldLabel + item.fieldId)} id={"drp" + item.fieldLabel + item.fieldId} 
                                        className="arrow-down ServiceRequest_dropdown" ref={el => {customFieldDdlRef.current[item.fieldId] = el}}>
                                        {default_drop_down_value}
                                        {customField_In_Select_Input}
                                    </select>
                                    <span id={item.fieldLabel + item.fieldId + "error"} hidden={true}>
                                        <img style={IconStyle} src={DangerImg} alt="danger_img" />
                                        <label style={{ 'color': '#D52B1E', 'font-size': '12px', 'font-family': 'Arial', 'margin': '1px' }}></label>
                                    </span>
                                </Col>
                    }
                })
                // Push a new row for every set of two fields
                for (let row = 0; row < Math.ceil(customFieldsOrder.length / 2); row++) {
                    l_rows.push(
                        <div key={"div_"+row} className="row form-group">
                            {customFieldsRow.slice((row * 2), ((row + 1) * 2))}
                        </div>
                    );
                };
            }
            setCustomFieldList(l_rows)
        } 
    },[customFields])

    useEffect(() => {
        if(IsSubmitClicked){
            SubmitFormDetails();
        }
    },[IsSubmitClicked]);

    useEffect(() => {
        const {fieldLabel, required, isServiceRequestFormField} = WOTenantStdFieldDetails;
        if(isServiceRequestFormField){
            if(tenantLists !== null && tenantLists !== undefined && tenantLists.length){
                var tenant_In_Select_Input = tenantLists.map(el => (
                    <option id={el.tenantId}>{el.tenantName}</option>
                ));
            }
            const tenant_row =  <FormGroup row>
                                <Col sm={{ size: 6 }}>
                                    <label id="lblTenant" className={TenantError ? "ServiceRequest_Content_lbl RequesErrorMsg" : "ServiceRequest_Content_lbl"}>{required ? fieldLabel+" (req.)" : fieldLabel}</label>
                                    <br/>
                                    <select onFocus={()=>onCustomControlFocusChangeStyle("lblTenant","tenantError","tTenant")}  
                                            onBlur={()=>onBlurChangeStyle("lblTenant")} 
                                            id="tTenant" 
                                            className={TenantError ? "arrow-down ServiceRequest_dropdown RequesErrorMsgHighlight" : "arrow-down ServiceRequest_dropdown"}
                                            ref={TenantRef}>
                                    {default_drop_down_value}
                                    {tenant_In_Select_Input}             
                                    </select>
                                    <span id="tenantError" hidden={TenantError? false : true}>
                                        <img style={IconStyle} src={DangerImg} alt="danger_img" />
                                        <label style={{ 'color': '#D52B1E', 'font-size': '12px', 'font-family': 'Arial', 'margin': '1px' }}>{"Select "+fieldLabel}</label>
                                    </span>
                                </Col>
                            </FormGroup>
            setTenantListDropdown(tenant_row);
        }
    },[tenantLists, TenantError]);

    const onFocusChangeStyle = (id,errorid) =>{
        if(document.getElementById(id) != null){
            if(document.getElementById(errorid) != null && document.getElementById(errorid).hidden === false){
                document.getElementById(id).style.color = ""
            }else{
                document.getElementById(id).style.color = "rgb(32, 111, 207)"
            }
        }  
    }

    const onCustomControlFocusChangeStyle = (id,errorid,txtBoxId) =>{
        if(document.getElementById(id) != null){
            document.getElementById(id).style.color = "rgb(32, 111, 207)"
            if(document.getElementById(errorid) != null && document.getElementById(errorid).hidden === false){
                document.getElementById(errorid).hidden = true;
                document.getElementById(txtBoxId).classList.remove('RequesErrorMsgHighlight')
                document.getElementById(id).classList.remove('RequesErrorMsg')
            }
        }  
    }

    const onFocusEmailChangeStyle = (id,errorid,txtBoxId) =>{
        if(document.getElementById(id) != null){
            if(document.getElementById(errorid) != null && 
            document.getElementById(errorid).hidden === false &&
            EmailAddressErrorMsg === "Email id you entered is invalid" ){
                document.getElementById(id).style.color = ""
            }else{
                document.getElementById(txtBoxId).className = "ServiceRequest_Content_txtbox";
                document.getElementById(id).className ="ServiceRequest_Content_lbl";
                setEmailAddressError(false);
                document.getElementById(id).style.color = "rgb(32, 111, 207)";
            }
        }  
    }

    const onBlurChangeStyle = (id) =>{
        if(document.getElementById(id) != null){
            document.getElementById(id).style.color = ""
        }
    }

    const handleInput = ({ target: { value } }) => setPhone(value);

    //method to sort custom fields based on orderId
    const OnSort = (values) => {
        if(values !== null && values !== undefined && values !== "--"){
            return values.sort((a,b) => a.orderId - b.orderId)
        }
    }
    
    const SubmitFormDetails = () => {
        setIsSubmitClicked(false);
        var el = document.getElementsByClassName('ServiceRequest_Wrapper'); 
        if(el[0] !== undefined)
            el[0].scrollIntoView();
        if(!FirstNameError && !LastNameError && !EmailAddressError && !DescriptionError && !PhoneNumberError && !CustomFieldError && !TenantError){
            let data = {}, FullDescription = "", lFName = "", lLName = "";
            let AttachmentDetails = [];
            const formData = new FormData();
            if(FilesLists !== undefined && FilesLists !== null && FilesLists.length){             
                FilesLists.forEach(el => {
                    formData.append("file", el);
                });
            }

            lFName = FirstNameRef.current.value.trim();
            lLName = LastNameRef.current.value.trim();

            if(lFName !== ""){
                FullDescription = "Name: " + lFName + " ";
            }
            if(lLName !== ""){
                FullDescription = FullDescription !== "" ? (FullDescription + lLName) : ("Name: " + lLName);
            }
            if(PhoneNumber !== ""){
                if(FullDescription !== ""){
                    FullDescription = FullDescription + "\n";
                }
                FullDescription = FullDescription + "Phone Number: " + PhoneNumber;
            }
            FullDescription = FullDescription !== "" ? (FullDescription + "\n\n" + DescriptionRef.current.value.trim()) : DescriptionRef.current.value.trim();
            
            window.grecaptcha.enterprise.ready(() => {
                window.grecaptcha.enterprise.execute(SiteKey, { action: 'RequestServiceSubmit' }).then(token => {
                    if(token !== ""){                   
                        data = {
                        "WorkOrderForm": {
                            "FirstName": lFName,
                            "LastName": lLName,
                            "EmailAddress": EmailAddressRef.current.value.trim(),
                            "IsCustomerForm": true,
                            "IsPrivacyPolicyAgreed": chk_verbiage.current.checked,
                            "PhoneNumber": PhoneNumber,
                            "token": token
                        },
                        "Description": FullDescription,
                        "DueDate": '1753/01/01',
                        "WorkOrderAttachment": AttachmentDetails,
                        "WorkOrderCustomFields": CustomFieldCols,
                        "WorkOrderDetail":{
                            "TenantID": Number(TenantFieldValue)
                        }
                        };
                    if (FilesLists !== undefined && FilesLists !== null && FilesLists.length) {
                        if (formData !== undefined && formData !== null) {
                            const l_result = dispatch(SaveAttachmentFromServiceRequest(formData));
                            l_result.then((res) => {
                                if (res !== undefined && res !== null && res.length) {
                                    if (FilesLists !== undefined && FilesLists !== null && FilesLists.length) {
                                        let i = 0;
                                        FilesLists.forEach(el => {
                                            var FileItems = {
                                                "AttachmentName": el.name,
                                                "FileName": res[i++]
                                            }
                                            AttachmentDetails.push(FileItems);
                                        });
                                    }
                                    data.WorkOrderAttachment = AttachmentDetails;
                                    SubmitForm(data);
                                }
                            })
                        }
                    }
                    else {
                        SubmitForm(data);
                    }
                }else{
                    console.log("Token Null...");
                }
                });
            }); 
        }else{
            setShowError(true);
            setErrorMsg("Please correct all errors before continuing.")
        }
    }

    const SubmitForm = (data) => {
        setSaveClickedOnce(true);
        APIutil.postData(url.post_WorkOrder_Form,data).then((response) => {
            var id = response.data.workOrderId;
            if(id !== undefined){
                setServiceRequestID(id);
                setShowAlert(true);
                sendSingleAmplitudeEvent("Submit Work Order Service Request Form");
                setAmplitudeEvent("Create Work Order",{"Notify Others":0,"Page":'Service Request Form'});
            }
            setSaveClickedOnce(false);
        })
        ClearAllFields();
        ClearAllCustomFields();
        childAttachmentClearFunc.current();
    }

    const HandleCustomFieldError = (error,refs,item) => {
        if(error){
            refs.current[item.fieldId].previousElementSibling.previousElementSibling.classList.add('RequesErrorMsg');
            refs.current[item.fieldId].classList.add('RequesErrorMsgHighlight');
            refs.current[item.fieldId].nextElementSibling.removeAttribute('hidden');
            refs.current[item.fieldId].nextElementSibling.childNodes[1].innerText=(item.fieldType === 0 ? "Enter " : "Select  ")+ item.fieldLabel;

        }else{
            refs.current[item.fieldId].previousElementSibling.previousElementSibling.classList.remove('RequesErrorMsg');
            refs.current[item.fieldId].classList.remove('RequesErrorMsgHighlight');
            refs.current[item.fieldId].nextElementSibling.setAttribute('hidden',true);
            refs.current[item.fieldId].nextElementSibling.childNodes[1].innerText=""; 
        }
    }

    const OnSubmitFormClick = () =>{
        var IsNotBot = CheckingBot();
        if (IsNotBot) {
            APIutil.getDataAPI(url.get_WorkOrder_Form_Access).then(response => {
                if(response !== null && response !== undefined 
                    && response.values !== undefined && response.values[0].isServiceRequestEnabled){
                        
                        ClearAllError();
                        ClearAllCustomFieldsError();
                        var RegexAlphaSpaceDot = /^[a-zA-Z. ]*$/;
                        var RegexRestrictSpecialCharacter = /^[^<>;]+$/;
                        var RegexpEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

                        //Custom Fields Validation
                        var lCustomFieldCol = [];
                        if(customFields !== null && customFields !== undefined && customFields.length){
                            customFields.filter(el => el.isServiceRequestDisplay === true).forEach(el => {
                                if(customFieldTextRef.current[el.fieldId] !== undefined){
                                    var customFieldTxtValue = customFieldTextRef.current[el.fieldId].value.trim();
                                    if(el.required === true && customFieldTxtValue === ""){
                                        setCustomFieldError(true);
                                        HandleCustomFieldError(true,customFieldTextRef,el)
                                    }
                                    lCustomFieldCol.push({
                                        "CustomFieldID" : el.fieldId,
                                        "CustomFieldValueID" : 0,
                                        "CustomFieldTextValue" : customFieldTxtValue
                                    });
                                }else{
                                    var CustomFieldDdlIndex = customFieldDdlRef.current[el.fieldId].options.selectedIndex;
                                    var customFieldDdlValue = customFieldDdlRef.current[el.fieldId].options[CustomFieldDdlIndex].id;
                                    if(el.required === true && customFieldDdlValue === "0"){
                                        setCustomFieldError(true);
                                        HandleCustomFieldError(true,customFieldDdlRef,el);
                                    }
                                    lCustomFieldCol.push({
                                        "CustomFieldID" : el.fieldId,
                                        "CustomFieldValueID" : Number(customFieldDdlValue),
                                        "CustomFieldTextValue" : ""
                                    });
                                }
                            })
                            setCustomFieldCols(lCustomFieldCol);
                        }

                        //Tenant Field validation
                        if(WOTenantStdFieldDetails.isServiceRequestFormField){
                            var tenantIndex = TenantRef.current.options.selectedIndex;
                            var tenantIndexValue = TenantRef.current.options[tenantIndex].id;
                            if(WOTenantStdFieldDetails.required === true && tenantIndexValue === "0")
                                setTenantError(true);
                            else
                                setTenantError(false);
                            setTenantFieldValue(tenantIndexValue);
                        }
                       
                        var lFirstName = FirstNameRef.current.value.trim();
                        var lLastName = LastNameRef.current.value.trim();
                        var lEmailAddress = EmailAddressRef.current.value.trim();
                        var lDescription = DescriptionRef.current.value.trim();
                        var lPhoneNumberLength = PhoneNumber.replace(/\D/g, '').length;
                        (lFirstName !== "" && !lFirstName.match(RegexAlphaSpaceDot)) ? setFirstNameError(true) : setFirstNameError(false);
                        (lLastName !== "" && !lLastName.match(RegexAlphaSpaceDot)) ? setLastNameError(true) : setLastNameError(false);
                        (lDescription !== "" && !lDescription.match(RegexRestrictSpecialCharacter)) ? setDescriptionError(true) : setDescriptionError(false);
                        if(PhoneNumber !== ""){
                            if(lPhoneNumberLength !== 10){
                                setPhoneNumberError(true);
                                setPhoneNumberErrorMsg('Phone Number you entered is invalid');
                            }
                            else{
                                setPhoneNumberError(false);
                            }
                        }

                        if (lEmailAddress !== "") {
                            if (!lEmailAddress.match(RegexpEmail)) {
                                setEmailAddressError(true);
                                setEmailAddressErrorMsg('Email id you entered is invalid');
                            }
                        } else {
                            setEmailAddressError(true);
                            setEmailAddressErrorMsg('Enter Email Address');
                        }
                        setIsSubmitClicked(true);

                }else{
                    ClearAllError();
                    ClearAllCustomFieldsError();
                    setShowError(true);
                    setErrorMsg("The form has been disabled. For help contact your Tracer Ensemble Administrator.")
                }

            }).catch(error => { throw error; })
            
        }
    }

    const CheckingBot = () => {
        let IsHuman = true;
        var l_FirstName = txtfirstName.current.value;
        var l_LastName = txtlastName.current.value;
        var l_EmailAddress = txtemailAddress.current.value;
        var l_PhoneNo = txtPhoneNo.current.value;
        var l_Description = txtdescription.current.value;
        if(l_FirstName !== "" || l_LastName !== "" || l_EmailAddress !== "" || l_Description !== "" || l_PhoneNo !== ""){
            APIutil.postData(url.post_WorkOrder_Form_Log,null).then(response => {
                console.log("Logged..");
            }).catch(error => { throw error; })
            IsHuman = false;
        }
        return IsHuman;
    }

    const ClearAllFields = () => {
        FirstNameRef.current.value = "";
        LastNameRef.current.value = "";
        EmailAddressRef.current.value = "";
        DescriptionRef.current.value = "";
        chk_verbiage.current.checked = false;
        if(WOTenantStdFieldDetails.isServiceRequestFormField){
            TenantRef.current.options.selectedIndex = "0"
        }
        setPhone('');
        setIsVerbiageChecked(false);
        setFilesLists([]);
    }

    const ClearAllCustomFields = () => {
        if(customFields !== null && customFields !== undefined && customFields.length){
            customFields.filter(el => el.isServiceRequestDisplay === true).forEach(el => {
                if(customFieldTextRef.current[el.fieldId] !== undefined)
                    customFieldTextRef.current[el.fieldId].value = ""
                else
                    customFieldDdlRef.current[el.fieldId].options.selectedIndex = "0"
            })
        }
    }

    const ClearAllError = () => {
        setFirstNameError(false);
        setLastNameError(false);
        setEmailAddressError(false);
        setDescriptionError(false);
        setEmailAddressErrorMsg(false);
        setPhoneNumberError(false);
        setShowError(false);
        setShowAlert(false);
        setTenantError(false);
        setErrorMsg("");
    }

    const ClearErrorMsg = () => {
        setShowError(false);
        setErrorMsg("");
    }

    const ClearAllCustomFieldsError = () => {
        setCustomFieldError(false);
        if(customFields !== null && customFields !== undefined && customFields.length){
            customFields.filter(el => el.isServiceRequestDisplay === true).forEach(el => {
                if(customFieldTextRef.current[el.fieldId] !== undefined)
                    HandleCustomFieldError(false,customFieldTextRef,el);
                else
                    HandleCustomFieldError(false,customFieldDdlRef,el);
            })
        }
    }

    const AddUploadedFiles = (FilesList) => {
        setFilesLists(FilesList);
    }

    

    return (
        <div className="ServiceRequest_content_container">
            <Form className="ServiceRequest_form_container"> 
                <FormGroup row>
                    <Col sm={{ size:12 }} style={{'transform':'translate(0px,-60px)'}}>
                        <Alert show={ShowAlert} variant="success" id="ServiceRequestSuccesAlert">
                            <span class="Alert_Closebtn" onClick={() => setShowAlert(false)}>×</span>
                            <span><img style={{"float":"left","width":"17px","height":"17px"}} src={SuccessImg} alt="alert_img" /></span>
                            <span class="Alert_Successlbl">Request Submitted!</span>
                            <div class="Alert_SuccessMsglbl">Thanks for your request.Your request ID is {"WK"+serviceReuqestID}. You will receive a confirmation email shortly. Once your request is taken care of and closed, you will be notified via email.</div>
                        </Alert>
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Col sm={{ size:12 }} style={{'transform':'translate(0px,-60px)'}}>
                        <Alert show={ShowError} variant="danger" id="ServiceRequestDanger" style={{borderRadius:'10px',border:'2px solid #991909'}}>
                            <span class="Alert_Closebtn" onClick={() => ClearErrorMsg()}>×</span>
                            <span><img style={{"float":"left","width":"17px","height":"17px"}} src={DangerImg} alt="danger_img" /></span>
                            <span class="Alert_Dangerlbl">Error</span>
                            <div class="Alert_DangerMsglbl">{ErrorMsg}</div>
                        </Alert>
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Col sm={{ size: 4 }}>
                        <label className="ServiceRequest_Header_lbl">Request Service</label>
                        <label className="ServiceRequest_Name_lbl">{companyName}</label>
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Col sm={{ size: 6 }} id="ServiceRequestName">
                        <label id="lblFirstName" className={FirstNameError ? "ServiceRequest_Content_lbl RequesErrorMsg" : "ServiceRequest_Content_lbl"}>First Name</label>
                        <br />
                        <input onFocus={()=>onFocusChangeStyle("lblFirstName","firstNameError")}  onBlur={()=>onBlurChangeStyle("lblFirstName")} type="text" maxLength="50" autoComplete="do-not-show-ac" className={FirstNameError ? "ServiceRequest_Content_txtbox RequesErrorMsgHighlight" : "ServiceRequest_Content_txtbox"} ref={FirstNameRef} id="tFirstName" />
                        <span id="firstNameError" hidden={FirstNameError ? false : true}>
                            <img style={IconStyle} src={DangerImg} alt="danger_img" />
                            <label style={{ 'color': '#D52B1E', 'font-size': '12px', 'font-family': 'Arial', 'margin': '1px' }}>Entered invalid values</label>
                        </span>
                    </Col>
                    <Col sm={{ size: 6 }}>
                        <label id="lblLastName" className={LastNameError ? "ServiceRequest_Content_lbl RequesErrorMsg" : "ServiceRequest_Content_lbl"}>Last Name</label>
                        <br />
                        <input onFocus={()=>onFocusChangeStyle("lblLastName","lastNameError")}  onBlur={()=>onBlurChangeStyle("lblLastName")} type="text" maxLength="50" autoComplete="do-not-show-ac" className={LastNameError ? "ServiceRequest_Content_txtbox RequesErrorMsgHighlight" : "ServiceRequest_Content_txtbox"} ref={LastNameRef} id="tLastName" />
                        <span id="lastNameError" hidden={LastNameError ? false : true}>
                            <img style={IconStyle} src={DangerImg} alt="danger_img" />
                            <label style={{ 'color': '#D52B1E', 'font-size': '12px', 'font-family': 'Arial', 'margin': '1px' }}>Entered invalid values</label>
                        </span>
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Col sm={{ size: 6 }} id="ServiceRequestEmail">
                        <label id="lblEmail" className={EmailAddressError ? "ServiceRequest_Content_lbl RequesErrorMsg" : "ServiceRequest_Content_lbl"}>Email Address (req.)</label>
                        <br />
                        <input onFocus={()=>onFocusEmailChangeStyle("lblEmail","emailError","tEmail")}  onBlur={()=>onBlurChangeStyle("lblEmail")} type="text" maxLength="320"  autoComplete="do-not-show-ac" className={EmailAddressError ? "ServiceRequest_Content_txtbox RequesErrorMsgHighlight" : "ServiceRequest_Content_txtbox"} ref={EmailAddressRef} id="tEmail" />
                        <span id="emailError" hidden={EmailAddressError ? false : true}>
                            <img style={IconStyle} src={DangerImg} alt="danger_img" />
                            <label style={{ 'color': '#D52B1E', 'font-size': '12px', 'font-family': 'Arial', 'margin': '1px' }}>{EmailAddressErrorMsg}</label>
                        </span>
                    </Col>
                    <Col sm={{ size: 6 }}>
                    <label id="lblPhoneNumber" className={PhoneNumberError ? "ServiceRequest_Content_lbl RequesErrorMsg" : "ServiceRequest_Content_lbl"}>Phone Number</label>
                        <br />
                        <InputMask onFocus={()=>onFocusChangeStyle("lblPhoneNumber","phoneNumberError")}  onBlur={()=>onBlurChangeStyle("lblPhoneNumber")} className={PhoneNumberError ? "ServiceRequest_Content_txtbox RequesErrorMsgHighlight" : "ServiceRequest_Content_txtbox"} style={{ 'width': '45%', 'letterSpacing': '1px' }}
                            mask="(999)999-9999"
                            value={PhoneNumber}
                            onChange={handleInput}
                            id='iPhoneNumber'
                            autoComplete='do-not-show-ac'
                            placeholder="(___)___-____"
                            >
                        </InputMask>
                        <input type="text" style={{display : 'none'}} ref={txtPhoneNo} id="PhoneNo"></input>
                        <br />
                        <span id="phoneNumberError" hidden={PhoneNumberError ? false : true}>
                            <img style={IconStyle} src={DangerImg} alt="danger_img" />
                            <label style={{ 'color': '#D52B1E', 'font-size': '12px', 'font-family': 'Arial', 'margin': '1px' }}>{PhoneNumberErrorMsg}</label>
                        </span>
                    </Col>
                </FormGroup>
                {TenantListDropdown}
                {CustomFieldList}
                <FormGroup row>
                    <Col sm={{ size: 12 }}>
                        <label id="lblDescription" className={DescriptionError ? "ServiceRequest_Content_lbl RequesErrorMsg" : "ServiceRequest_Content_lbl"}>Description</label>
                        <br />
                        <textarea onFocus={()=>onFocusChangeStyle("lblDescription","descriptionError")}  onBlur={()=>onBlurChangeStyle("lblDescription")} maxLength="500" autoComplete="do-not-show-ac" className={DescriptionError ? "ServiceRequest_Content_txtarea RequesErrorMsgHighlight" : "ServiceRequest_Content_txtarea" } ref={DescriptionRef} id="tDescription" />
                        <span id="descriptionError" hidden={DescriptionError ? false : true}>
                            <Icon name='exclamation triangle' style={{ 'color': '#D52B1E'}} />
                            <label style={{ 'color': '#D52B1E', 'font-size': '12px', 'font-family': 'Arial' }}>Entered invalid values</label>
                        </span>

                        <label class="ServiceRequest_txtContent" for="firstName"></label>
                        <input class="ServiceRequest_txtContent" autocomplete="do-not-show-ac" type="text" ref={txtfirstName} id="firstName" name="firstName" placeholder="Your first name here" />
                        <label class="ServiceRequest_txtContent" for="lastName"></label>
                        <input class="ServiceRequest_txtContent" autocomplete="do-not-show-ac" type="text" ref={txtlastName} id="lastName" name="lastName" placeholder="Your last name here" />
                        <label class="ServiceRequest_txtContent" for="emailAddress"></label>
                        <input class="ServiceRequest_txtContent" autocomplete="do-not-show-ac" type="email" ref={txtemailAddress} id="emailAddress" name="emailAddress" placeholder="Your e-mail here" />
                        <label class="ServiceRequest_txtContent" for="comments"></label>
                        <input class="ServiceRequest_txtContent" autocomplete="do-not-show-ac" type="text" ref={txtdescription} id="description" name="commdescriptionents" placeholder="Your descriptiopn here" />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Col sm={{ size: 12 }}>
                        <label className="ServiceRequest_Content_lbl">Attachments</label>
                        <br />
                        <Attachments UploadedFiles={AddUploadedFiles} childAttachmentClearFunc={childAttachmentClearFunc} />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Col sm={{ size: 12 }}>
                    <input type="checkbox" style={{'margin-top':'3px', 'float': 'left', 'cursor': 'pointer'}} id="chk_verbiage" defaultChecked={false} ref={chk_verbiage} onChange={(e) => setIsVerbiageChecked(e.target.checked)} />
                    <div style={{'padding-left':'20px'}}>
                        <span className="ServiceRequest_verbiage">By clicking the submit button below in the Work Order Service Request form, you agree to our
                        <a href="https://www.tranetechnologies.com/en/index/terms-of-use.html" target={"_blank"} rel={"noreferrer"}>{" Terms of Use "}</a>
                        and acknowledge that the information you provide will be processed in accordance with our
                        <a href="https://www.tranetechnologies.com/en/index/privacy-policy.html" target={"_blank"} rel={"noreferrer"}>{" Privacy Policy."}</a>
                        </span>
                    </div>
                    </Col>
                </FormGroup>
                <br/>
                <FormGroup row>
                    <Col sm={{ size: 12 }} style={{"padding-right": "20px"}}>
                        <Button className="ServiceRequest_btn" style={{background:colorCode, color:textColor}} disabled={!IsVerbiageChecked || IsSaveClickedOnce} onClick={() => OnSubmitFormClick()}>Submit</Button>
                    </Col>
                </FormGroup>
            </Form>
        </div>
    )
}